import React, { useEffect, useRef } from 'react'
import clinqo from '../assets/Clinqo.svg'
import { useLocation } from 'react-router-dom';

export const HeroSection = ({ scrollToContactSales, scrollToWhyUs }) => {
    const hero = useRef('');
    const { pathname } = useLocation();
    useEffect(() => {
        if (hero.current && (pathname === '/home' || pathname === '/')) {
            hero.current.scrollIntoView({ behavior: 'instant' });
        }
    }, [pathname]);
    return (
        <div ref={hero} className='flex items-center max-lg:flex-col-reverse flex-wrap justify-between p-[5vw] min-h-[100vh] pt-[10vh] w-full gap-10'>
            <div className='lg:w-[40%] w-[90%]'>

                {/* // This is the hero Title */}
                <h1 className='lg:text-5xl text-3xl font-bold'>
                    Simplify Your Clinical
                    <br />
                    Journey with  <span className='inline-block text-blue-500'> Clinqo</span>
                </h1>

                {/* // This is the hero description */}
                <p className='lg:text-xl text-base mt-5'>Seamless Appointments, Exceptional Care. Your Journey to Clinical Excellence Begins Now.</p>

                {/* // This is the hero buttons */}
                <div className="buttons flex flex-wrap w-full justify-between mt-10">
                    <button className='bg-gradient-to-br from-[#132893] to-[#2162DE] text-2xl px-11 py-4 text-white font-semibold rounded-xl mt-5' onClick={scrollToContactSales}>
                        Be a Clinqer
                    </button>
                    <button className='border-blue-500  text-2xl px-11 py-4 text-blue-500 font-semibold rounded-xl border-[2px] mt-5' onClick={scrollToWhyUs}>
                        Learn More
                    </button>
                </div>

            </div>

            {/* // This is the hero image */}
            <img className='lg:w-[40%] w-[90%]' src={clinqo} alt="Clinqo Logo" />
        </div>
    )
}
